import { ReactNode } from 'react';

interface Props {
  children?: ReactNode;
}

export const Container = ({ children }: Props) => {
  return (
    <main className="flex flex-1 flex-col gap-4 p-6 px-4 md:gap-8 md:p-8">
      <div className="container px-0 py-0 mx-auto">{children}</div>
    </main>
  )
};
